import React from "react"
import Button, { ButtonOwnProps } from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import { ButtonBaseProps, Tooltip, TooltipProps } from "@mui/material"

// A component that shows a circular progress within it while it's doing
// something. See here:
// https://material-ui.com/demos/progress/
type Props = {
  children: React.ReactNode
  clickedCallback?: () => void | Promise<void>
  isLoading: boolean
  style?: object
  type?: ButtonBaseProps["type"]
  loadingText?: string
  color?: ButtonOwnProps["color"]
  variant?: ButtonOwnProps["variant"]
  isDisabled?: boolean
  fullWidth?: boolean
  className?: string
  toolTipTitle?: string
  toolTipPlacement?: TooltipProps["placement"]
  testId?: string
  id?: string
}

const ButtonWithProgress = ({
  isLoading,
  clickedCallback,
  children,
  style = {},
  type = "button",
  loadingText = "Loading...",
  color = "primary",
  variant = "contained",
  isDisabled = false,
  fullWidth,
  className,
  toolTipTitle,
  toolTipPlacement = "top",
  testId,
  id,
}: Props) => {
  const handleButtonClick = () => {
    if (clickedCallback) {
      clickedCallback()
    }
  }

  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ position: "relative", width: "100%" }}>
        <Tooltip title={toolTipTitle} arrow placement={toolTipPlacement}>
          <span>
            <Button
              id={id}
              className={className}
              data-cy={testId || "btn-with-progress"}
              fullWidth={fullWidth}
              variant={variant}
              color={color}
              disabled={isLoading || isDisabled}
              type={type}
              onClick={type !== "submit" ? handleButtonClick : undefined}
            >
              {isLoading ? loadingText : children}
            </Button>
          </span>
        </Tooltip>
        {isLoading && (
          <CircularProgress
            size={24}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: -12,
              marginLeft: -12,
            }}
          />
        )}
      </div>
    </div>
  )
}

export default ButtonWithProgress
